export default __webpack_public_path__ + "static/ranking-hero-ef8124d7255aeaf02e252cf065ce36db.png";